// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
table {
  width: 100%;
  align-items: center;
}

footer {
  background-color: #90CAFC;
}

.header {
  background-color: #90CAFC;
  color: black;
}

.app-name {
  font-size: large;
}

.sub-header {
  background-color: #CCE2F5;
}

.page-title {
  font-size: large;
}

.main-area {
  background-color: azure;
}

.button-header {
  text-align: center;
  background-color: ghostwhite;
}

.button {
  text-align: center;
  background-color: ghostwhite;
}

.tenant-name-header,
.tenant-name {
  text-align: center;
  background-color: white;
  width: 15%;
}

.partition-name-header,
.partition-name {
  text-align: center;
  background-color: whitesmoke;
  width: 8%;
}

.updateBy-header,
.updateBy {
  background-color: whitesmoke;
  text-align: center;
  width: 10%;
}

.updateAt-header,
.updateAt {
  background-color: white;
  text-align: center;
  width: 10%;
}

.note {
  text-align: left;
  padding-left: 20px;
  background-color: whitesmoke;
  width: 18%;
  overflow: hidden; /* 超出一行文字自动隐藏 */
  text-overflow: ellipsis; /*文字隐藏后添加省略号*/
  word-break: break-all;
}

.note-header {
  text-align: center;
  background-color: whitesmoke;
  width: 15%;
}

.contractedAt-header,
.contractedAt {
  text-align: center;
  background-color: white;
  width: 8%;
}

.cancelledAt-header,
.cancelledAt {
  text-align: center;
  background-color: white;
  width: 8%;
}

.is-card-header,
.is-card {
  text-align: center;
  background-color: whitesmoke;
  width: 5%;
}

.edit-button {
  min-width: max-content;
}

.delete-button {
  background-color: lightcoral;
  min-width: max-content;
}

::ng-deep .mat-mdc-form-field-type-mat-select:not(.mat-form-field-disabled) .mat-mdc-text-field-wrapper {
  background: inherit;
}

.pull-down {
  padding-top: 20px;
  min-width: auto;
}

.textbox {
  padding-top: 20px;
}

.master-edit-component-all {
  flex-wrap: wrap;
}

.master-edit-component-main {
  flex: 1;
  height: 94vh;
}

.main-area {
  height: 100%;
  overflow-y: auto;
  background-color: white;
}

.menu-list {
  height: 100%;
}

.no-tenant {
  color: darkorange;
}

.footer {
  width: 100%;
  bottom: 0; /*下に固定*/
  position: fixed;
}`, "",{"version":3,"sources":["webpack://./src/app/feature/master-edit/master-edit.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACI,WAAA;EACA,mBAAA;AACJ;;AAEA;EACI,yBCPa;ADQjB;;AAEA;EACI,yBCXa;EDYb,YAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,4BAAA;AACJ;;AAEA;EACI,kBAAA;EACA,4BAAA;AACJ;;AAEA;;EAEI,kBAAA;EACA,uBAAA;EACA,UAAA;AACJ;;AACA;;EAEI,kBAAA;EACA,4BAAA;EACA,SAAA;AAEJ;;AACA;;EAEI,4BAAA;EACA,kBAAA;EACA,UAAA;AAEJ;;AACA;;EAEI,uBAAA;EACA,kBAAA;EACA,UAAA;AAEJ;;AACA;EACI,gBAAA;EACA,kBAAA;EACA,4BAAA;EACA,UAAA;EACA,gBAAA,EAAA,eAAA;EACA,uBAAA,EAAA,aAAA;EACA,qBAAA;AAEJ;;AAAA;EACI,kBAAA;EACA,4BAAA;EACA,UAAA;AAGJ;;AAAA;;EAEI,kBAAA;EACA,uBAAA;EACA,SAAA;AAGJ;;AAAA;;EAEI,kBAAA;EACA,uBAAA;EACA,SAAA;AAGJ;;AAAA;;EAEI,kBAAA;EACA,4BAAA;EACA,SAAA;AAGJ;;AAAA;EACI,sBAAA;AAGJ;;AAAA;EACI,4BAAA;EACA,sBAAA;AAGJ;;AACA;EACI,mBAAA;AAEJ;;AACA;EACI,iBAAA;EACA,eAAA;AAEJ;;AACA;EACI,iBAAA;AAEJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,OAAA;EACA,YAAA;AACJ;;AAEA;EACI,YAAA;EACA,gBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,WAAA;EAEA,SAAA,EAAA,OAAA;EACA,eAAA;AAAJ","sourcesContent":["@import \"variables\";\ntable{\n    width: 100%;\n    align-items: center\n}\n\nfooter{\n    background-color: $main-backgroud;\n}\n\n.header{\n    background-color: $main-backgroud;\n    color: black;\n}\n\n.app-name{\n    font-size: large;\n}\n\n.sub-header{\n    background-color: #CCE2F5;\n}\n\n.page-title{\n    font-size: large;\n}\n\n.main-area{\n    background-color:azure;\n}\n\n.button-header{\n    text-align: center;\n    background-color:ghostwhite;\n}\n\n.button{\n    text-align: center;\n    background-color:ghostwhite;\n}\n\n.tenant-name-header,\n.tenant-name{\n    text-align: center;\n    background-color:white;\n    width: 15%;\n}\n.partition-name-header,\n.partition-name{\n    text-align: center;\n    background-color:whitesmoke;\n    width: 8%;\n}\n\n.updateBy-header,\n.updateBy{\n    background-color: whitesmoke;\n    text-align: center;\n    width: 10%;\n}\n\n.updateAt-header,\n.updateAt{\n    background-color: white;\n    text-align: center;\n    width: 10%;\n}\n\n.note{\n    text-align: left;\n    padding-left: 20px;\n    background-color:whitesmoke;\n    width: 18%;\n    overflow: hidden;  /* 超出一行文字自动隐藏 */\n    text-overflow: ellipsis;  /*文字隐藏后添加省略号*/\n    word-break:break-all;\n}\n.note-header{\n    text-align: center;\n    background-color: whitesmoke;\n    width: 15%;\n}\n\n.contractedAt-header,\n.contractedAt{\n    text-align: center;\n    background-color: white;\n    width: 8%;\n}\n\n.cancelledAt-header,\n.cancelledAt{\n    text-align: center;\n    background-color: white;\n    width: 8%;\n}\n\n.is-card-header,\n.is-card{\n    text-align: center;\n    background-color: whitesmoke;\n    width: 5%;\n}\n\n.edit-button{\n    min-width: max-content;\n}\n\n.delete-button{\n    background-color: lightcoral;\n    min-width: max-content;\n\n}\n\n::ng-deep .mat-mdc-form-field-type-mat-select:not(.mat-form-field-disabled) .mat-mdc-text-field-wrapper {\n    background: inherit;\n}\n\n.pull-down {\n    padding-top: 20px;\n    min-width: auto;\n}\n\n.textbox {\n    padding-top: 20px;\n}\n\n// フッターを下に固定するための修正\n.master-edit-component-all {\n    flex-wrap: wrap;\n}\n\n.master-edit-component-main {\n    flex: 1;\n    height: 94vh;\n}\n\n.main-area {\n    height: 100%;\n    overflow-y: auto;\n    background-color: white;\n}\n\n.menu-list {\n    height: 100%;\n}\n\n.no-tenant{\n    color: darkorange;\n}\n\n.footer {\n    width: 100%;\n    // position: absolute;/*←絶対位置*/\n    bottom: 0; /*下に固定*/\n    position: fixed;\n}\n","$main-backgroud: #90CAFC;\n// 本番（PRD）：背景色を薄青（#90CAFC）にする\n// STG：背景色を薄緑（#66cdaa）にする\n// DEV：背景色を黄色（#ffd700）にする\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
